<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">List of Project
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()"> <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="3">
          <b-input-group>
            <b-input-group-prepend><span class="pt-2 mr-2">Project Name</span></b-input-group-prepend>
            <b-form-input v-model="filter.pjxname"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="3">
          <b-input-group>
            <b-input-group-prepend><span class="pt-2 mr-2">Project Type</span></b-input-group-prepend>
            <b-form-select v-model="filter.pjxjobtype" :plain="true" :options="filtertypes"></b-form-select>
          </b-input-group>
        </b-col>
        <b-col md="5">
          <b-row>
            <b-button class="btn btn-success ml-3 mr-1" @click="refresh()"> <i class="fa fa-refresh"></i> Apply
              Filter</b-button>
            <b-button class="btn btn-secondary mr-1" @click="clearFilter()"> <i class="fa fa-eraser"></i>Clear
              Filter</b-button>
          </b-row>
        </b-col>

      </b-row>

      <b-table class="mb-0" ref="table" outlined responsive hover small style="font-size:smaller;" :items="data"
        :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" @row-clicked="rowClicked" :key="tblData.limit" show-empty>
        <template #empty="scope">
          <h6 class="text-center">{{ scope.emptyText }}</h6>
        </template>
        <template #emptyfiltered="scope">
          <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
        </template>
        <template v-slot:cell(CustName)="data">
          <span v-if="(data.item.sales)">{{ data.item.CustName }}</span>
          <span v-else>Internal</span>
        </template>
        <template v-slot:cell(cust_po)="data">
          <span v-if="(data.item.sales)">{{ data.item.cust_po }}</span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click.stop="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="5">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span> <span
              v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="2">
          <b-input-group>
            <b-input-group-prepend><span class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit" size="sm"
              style="width:80px;" />
          </b-input-group>
        </b-col>
        <b-col cols="5">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit"
            v-model="tblData.page"></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">Project - Add/Edit Form
          </div>
          <b-input-group>
            <b-input-group-prepend><label>Project Name</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.pjxname" :state="!$v.frmdata.pjxname.$error"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Project Type</label></b-input-group-prepend>
            <b-form-select v-model="frmdata.pjxjobtype" :plain="true" :options="types"
              :state="!$v.frmdata.pjxjobtype.$error"></b-form-select>
            <b-form-radio-group v-model="frmdata.sales" name="radioIndividu" class="ml-1 mt-1">
              <b-form-radio :value="1">External(Sales)</b-form-radio>
              <b-form-radio :value="0">Internal</b-form-radio>
            </b-form-radio-group>
          </b-input-group>
          <b-row v-if="(frmdata.sales == 1)" no-gutters>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                <b-form-input readonly v-model="frmdata.custinfo" :state="!$v.frmdata.cust_id.$error"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuCustomerShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend><span class="pl-2 pt-2">Order#</span></b-input-group-prepend>
                <b-form-input v-model="frmdata.cust_po" placeholder="Customer Order No." class="ml-1"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend><label>Description</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.pjxdesc" :state="!$v.frmdata.pjxdesc.$error"></b-form-input>
          </b-input-group>
          <b-row>
            <b-col md="7">
              <b-input-group>
                <b-input-group-prepend><label>Project Code</label></b-input-group-prepend>
                <!-- <b-form-input v-model="frmdata.pjxcode" :state="!$v.frmdata.pjxcode.$error" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input> -->
                <b-form-input v-model="frmdata.pjxcode" :state="!$v.frmdata.pjxcode.$error"></b-form-input>
                <b-input-group-prepend><span class="input-group-text">(eg. YY-1234)</span></b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col md="5">
              <b-input-group>
                <b-input-group-prepend><label style="width:50px">Active</label></b-input-group-prepend>
                <b-form-select v-model="frmdata.isactive" :state="!$v.frmdata.isactive.$error" :plain="true"
                  :options="activeStatus"></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
          <div slot="footer" style="text-align:center;">
            <button class="btn btn-primary mr-1" @click="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()"> <i class="fa fa-close"></i> Close
              Form</b-button>
            <div v-if="$v.frmdata.sales.$error" style="color:red; margin-top:10px;">External/Internal is required</div>

          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
      <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal>

  </div>
</template>

<style lang="scss">
.input-group {
  padding-bottom: 2px;

  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 100px;
    }
  }
}
</style>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import lkuCustomer from "../lookup/lkuCustomer";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: { lkuCustomer },
  mixins: [validationMixin],
  validations: {
    frmdata: {
      pjxname: { required },
      pjxcode: { required },
      pjxjobtype: { required },
      sales: { required },
      pjxdesc: { required },
      isactive: { required },
      cust_id: {
        required: (function () {
          if (this.frmdata.sales == 0) {
            return true;
          } else {
            if ((this.frmdata.cust_id || '') == '') {
              return false;
            } else {
              return true;
            }
          }
        })
      },
    },
  },
  data() {
    return {
      showDelConfirm: false,
      showList: true,
      showForm: false,
      lkuCustomerShow: false,
      frmdata: { cust_id:'',custinfo:'', pjxcode: '', pjxname: '', pjxjobtype: '', pjxdesc: '', sales: 1, isactive: 1 },
      types: [], filtertypes: [{ value: '', text: '--ALL--' }],
      studiolives: [], studiotapes: [], spotrates: [],
      activeStatus: [{ value: '', text: '-- ALL --' }, , { value: '0', text: 'Non Active' }, { value: '1', text: 'Active/In Use' }],
      tblData: {
        tablename: 'vwproject',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      filter: { pjxname: '', pjxjobtype: '' }
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "pjxcode",
          label: "Project Code",
          thStyle: "width:120px",
          sortable: true
        },
        {
          key: "pjxname",
          label: "Project Name",
          sortable: true
        },
        {
          key: "job_name",
          label: "Project Type",
          sortable: true
        },
        {
          key: "pjxdesc",
          label: "Description",
          sortable: true
        },
        {
          key: "CustName",
          label: "Customer Name",
          sortable: true
        },
        {
          key: "cust_po",
          label: "Customer Order#",
          thStyle: "width:120px",
          sortable: true
        },
        {
          key: "isactive",
          label: "Active",
          thStyle: "width:60px",
          thClass: "text-center",
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:60px",
          thClass: "text-center",
        }
      ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function () {
    const [a] = await Promise.all([
      crud.list({
        tablename: 'projecttype',
        page: 1,
        limit: 1000,
        total: 0,
        sortBy: 'job_name',
        sortDesc: false
      })
    ]);
    this.types = a.reduce((newArr, item) => {
      newArr.push({ value: item.id, text: item.job_name });
      return newArr;
    }, []);
    // this.filtertypes = a.reduce((newArr,item) =>{
    //     newArr.push({ value: item.id, text: item.job_name});
    //     return newArr;
    // },[{value:'', text:'--ALL--'}]);
    this.filtertypes = this.filtertypes.concat(this.types);
  },
  methods: {
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.customQuery = '';
      let str = '';
      if (this.filter.pjxname) {
        str = 'pjxname=%' + encodeURIComponent(this.filter.pjxname) + '%';
      }
      if (this.filter.pjxjobtype) {
        str += str ? '&' : '';
        str = str + 'pjxjobtype=' + encodeURIComponent(this.filter.pjxjobtype);
      }
      this.tblData.customQuery = str;

      const list = await crud.list(this.tblData);
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.filter.pjxname = '';
      this.filter.pjxjobtype = '';
      this.refresh();
    },

    add: function (data) {
      for (var key in this.frmdata) {
        this.frmdata[key] = '';
      }
      this.frmdata.isactive = 1;
      this.showForm = true;
      this.showList = false;
    },
    edit: async function (data) {
      this.model = data;
      for (var key in this.frmdata) {
        this.frmdata[key] = '';
      }
      for (var key in this.model) {
        this.frmdata[key] = this.model[key];
      }
      this.frmdata.idlama = data.pjxkey;
      this.frmdata.isactive = this.frmdata.isactive || 0;
      this.frmdata.custinfo = data.CustName.trim() + ' | ' + data.CustCode.trim();
      this.showForm = true;
      this.showList = false;

    },
    save: async function (callback) {
      if (this.invalidFormdata) {
        console.log('validation : ', this.$v.frmdata);
        console.log('frmdata : ', this.frmdata);
        toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
        try {
          console.log('frmdata : ', this.frmdata);
          if (this.frmdata.idlama) {
            await crud.update(
              {
                tablename: 'project',
                key: this.frmdata.idlama,
                data: {
                  pjxname: this.frmdata.pjxname, pjxcode: this.frmdata.pjxcode, pjxjobtype: this.frmdata.pjxjobtype, pjxdesc: this.frmdata.pjxdesc,
                  sales: this.frmdata.sales, cust_id: this.frmdata.cust_id, cust_po: this.frmdata.cust_po, isactive: this.frmdata.isactive,
                  createby:this.$store.state.user.username,
                }
              });
          } else {
            await crud.insert(
              {
                tablename: 'project',
                data: {
                  pjxname: this.frmdata.pjxname, pjxcode: this.frmdata.pjxcode, pjxjobtype: this.frmdata.pjxjobtype, pjxdesc: this.frmdata.pjxdesc,
                  sales: this.frmdata.sales, cust_id: this.frmdata.cust_id, cust_po: this.frmdata.cust_po, isactive: this.frmdata.isactive,
                  modifiedby:this.$store.state.user.username,
                }
              });
          }
          this.closeFrm();
          setTimeout(() => {
            this.refresh();
          }, 500);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function () {
      await crud.remove({ tablename: 'project', key: this.model.pjxkey });
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = 'info';
      this.$forceUpdate();
    },
    onSelectLkuCustomer: async function (_selected) {
      this.frmdata.custinfo = _selected.CustName.trim() + ' | ' + _selected.CustCode.trim();
      this.frmdata.cust_id = _selected.customer_id;
      this.lkuCustomerShow = false;
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },
    close() {
      router.push("home");
    },
  }
};
</script>
